import React from 'react';
import PropTypes from 'prop-types';

export default function OrganizationalIcon(props) {
  const { fill, size } = props;

  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 20 20'>
      <g fill={fill} data-name='organizacional'>
        <path d='M9.852 8.259h1.016v5.133H9.852z' data-name='Retângulo 2628' />
        <path d='M7.106 8.259h1.016v5.133H7.106z' data-name='Retângulo 2629' />
        <path d='M15.34 8.259h1.016v5.133H15.34z' data-name='Retângulo 2630' />
        <path d='M12.596 8.259h1.016v5.133h-1.016z' data-name='Retângulo 2631' />
        <path d='M10.372 2 2.521 7.243h15.7Z' data-name='Caminho 22031' />
        <path d='M16.85 14.407H3.894L2 18.195h16.717Z' data-name='Caminho 22030' />
        <path d='M4.387 8.259h1.016v5.133H4.387z' data-name='Retângulo 2632' />
      </g>
      <path fill='none' d='M0 0h20v20H0z' data-name='Retângulo 148050' />
    </svg>
  );
}

OrganizationalIcon.defaultProps = {
  size: '20',
  fill: '#4b4b4b'
};

OrganizationalIcon.propTypes = {
  fill: PropTypes.string,
  size: PropTypes.string
};
